"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AppAriImpls_1 = require("./AppAriImpls");
var AppFamilyAri;
(function (AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [AppFamilyAri.appResourceType, AppFamilyAri.environmentResourceType, AppFamilyAri.extensionGroupResourceType, AppFamilyAri.extensionResourceType];
})(AppFamilyAri = exports.AppFamilyAri || (exports.AppFamilyAri = {}));
var AppFamilyAriError = /** @class */ (function (_super) {
    __extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error));
exports.AppFamilyAriError = AppFamilyAriError;
var NotAppFamilyAriError = /** @class */ (function (_super) {
    __extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}(AppFamilyAriError));
exports.NotAppFamilyAriError = NotAppFamilyAriError;
var NotExpectedAppFamilyAriTypeError = /** @class */ (function (_super) {
    __extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}(AppFamilyAriError));
exports.NotExpectedAppFamilyAriTypeError = NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */
function parseAppAri(ari) {
    return AppAriImpls_1.AppFamilyAriImpl.parse(ari);
}
exports.parseAppAri = parseAppAri;
function createAppAri(json) {
    return new AppAriImpls_1.AppFamilyAriImpl(json);
}
exports.createAppAri = createAppAri;
//# sourceMappingURL=AppAris.js.map